module.exports = __webpack_public_path__ + "img/bullshitfrei.95867786.png";